<div class="activity-details solo activity-initiator-commit" c-toggle="viewVisible"  c-toggle-options="{type: 'fade'}">
    <div id="content">
    </div>
</div>